<template>
  <div class="p-auth p-auth--single">
    <section class="p-auth__panel">
      <div class="p-auth__form">
        <header class="p-auth__head p-auth__head--center">
          <img src="/favicon.png" alt="Pineapple" class="p-auth__icon" />
          <p class="p-auth__head-eyebrow">FOR {{ $CONF.APP_USERTYPE }}</p>
          <h1 class="p-auth__head-title">Sign in</h1>
          <p class="p-auth__head-sub">Welcome back</p>
        </header>

        <form class="p-auth__veeform" @submit.prevent>
          <div class="p-field">
            <label class="p-field__label" for="basic-email">
              <i class="material-icons-round p-field__label-icon">mail</i>
              이메일
            </label>
            <input id="basic-email" type="email" placeholder="name@example.com" class="p-input" />
          </div>

          <div class="p-field">
            <label class="p-field__label" for="basic-password">
              <i class="material-icons-round p-field__label-icon">lock</i>
              비밀번호
            </label>
            <input id="basic-password" type="password" placeholder="••••••••" class="p-input" />
          </div>

          <label class="p-auth__remember">
            <input type="checkbox" /> 로그인 상태 유지
          </label>

          <ABtn type="submit" kind="primary" block icon="login" class="p-auth__submit">Sign in</ABtn>

          <p class="p-auth__alt">
            계정이 없으신가요?
            <router-link :to="{ name: 'Signup Cover' }">회원가입</router-link>
          </p>
        </form>

        <p class="p-auth__footer">© {{ new Date().getFullYear() }} Pineapple Academy</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ABtn from "@/components/Pineapple/ABtn.vue";

export default {
  name: "SigninBasic",
  components: { ABtn },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.p-auth {
  min-height: 100vh;
  background: $p-bg;
  font-family: $p-font-body;
  display: grid;
  place-items: center;
  padding: 24px;
}

.p-auth__panel {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-lg;
  box-shadow: 0 20px 60px rgba(31, 27, 20, 0.10);
  width: 100%;
  max-width: 420px;
  padding: 36px;
}

.p-auth__form { display: flex; flex-direction: column; gap: 24px; }

.p-auth__head {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &--center {
    text-align: center;
    align-items: center;
  }
}

.p-auth__icon {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
}

.p-auth__head-eyebrow {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  color: $p-point-deep;
  margin: 0;
}

.p-auth__head-title {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: $p-ink;
}

.p-auth__head-sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: $p-ink-mid;
}

.p-auth__veeform { display: flex; flex-direction: column; gap: 4px; }

.p-auth__remember {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: $p-ink-mid;
  cursor: pointer;
  margin-top: -4px;

  input { accent-color: $p-point-deep; }
}

.p-auth__submit {
  margin-top: 8px;
  height: 42px !important;
}

.p-auth__alt {
  text-align: center;
  font-size: 13px;
  color: $p-ink-mid;
  margin: 8px 0 0;

  a {
    color: $p-point-deep;
    font-weight: 700;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
}

.p-auth__footer {
  margin: 16px 0 0;
  text-align: center;
  font-size: 11px;
  color: $p-ink-soft;
}
</style>
